<template>
  <a-layout>
    <a-layout-content :style="{ backgroundColor: 'white' }">
      <div class="chart-nav">
        <a-menu v-model="current" mode="horizontal">
          <a-menu-item
            key="count"
            :class="
              current[0] === 'count'
                ? 'chart-title-bold chart-title'
                : 'chart-title'
            "
          >
            推广量
          </a-menu-item>
          <!--          <a-menu-item key="top" :class=" current[0] === 'top'?'chart-title-bold chart-title':'chart-title'">-->
          <!--            推广量TOP 10-->
          <!--          </a-menu-item>-->
        </a-menu>
      </div>
      <div class="chart-content" id="count" />
      <!--      <div class="chart-content" id="top"/>-->
    </a-layout-content>
  </a-layout>
</template>

<script>
import { getProgramData } from "@/api/program";

// const topData = [
//   { type: '用户1', value: 34 },
//   { type: '用户2', value: 85 },
//   { type: '用户3', value: 103 },
//   { type: '用户4', value: 142 },
//   { type: '用户5', value: 251 },
//   { type: '用户6', value: 367 },
//   { type: '用户7', value: 491 },
//   { type: '用户8', value: 672 },
//   { type: '用户9', value: 868 },
//   { type: '用户10', value: 1234 },
// ]

export default {
  name: "Statistical",
  data() {
    return {
      current: ["count"],
      countData: [],
      topData: [],
      // char
      countChart: null,
      topChart: null,
    };
  },
  created() {
    let query = this.$route.query;
    /* 数据总数 */
    getProgramData({ id: query.id }).then((res) => {
      console.log(res);
    });
  },
  methods: {},
};
</script>

<style scoped></style>
